import axios from 'axios'
import { authHeader } from '../util/authHeader'

const baseUrl = process.env.VUE_APP_API_BASE_URL + '/api/v2/'

export const appSettingsService = {
    getMerchantAccountId
}

async function getMerchantAccountId() {
    return await axios
        .get(baseUrl + 'appsettings/merchantAccountId')
        .then((response) => {
            return response.data;
        }).catch((error) => {
            if (error.response) {
                const data = error.response.data;
                throw data;
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}